import { FadeIn, SectionHeader, IconBox } from '../components/UI';

const values = [
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'Güvenilirlik',
    desc: '%99.9 uptime ve sıfır veri kaybı garantisiyle daima yanınızdayız.',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    ),
    title: 'Holistik İnovasyon',
    desc: 'Finans, İK ve Bankacılık modüllerini bütünleşik bir pazar yerinde bir araya getiriyoruz.',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
      </svg>
    ),
    title: 'Müşteri Odaklılık',
    desc: '7/24 destek ekibimiz ve özelleştirilebilir modüllerimizle her işletmeye özel yaklaşım.',
  },
];

const corporate = [
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Kimiz',
    desc: 'Alanında 20+ yıllık tecrübeli Mali Müşavirler, Yeminli Mali Müşavirler ve Yazılım Ekibinin bir araya gelmesiyle oluşmuş, Dijital Denetim alanında yenilikleri anlık takip eden bir ekibiz.',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
      </svg>
    ),
    title: 'Vizyonumuz',
    desc: 'Parçalı Muhasebe yazılımların aksine, Denetim şirketleri veya Grup Şirketlerin ihtiyaç duyduğu tüm muhasebe araçlarının entegre çalıştığı bir "AĞ" yaratmak.',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" />
      </svg>
    ),
    title: 'Misyonumuz',
    desc: 'Karmaşık E-Dönüşüm düzenlemelerini basitleştirip tek platformda bütünleştirerek, Muhasebe Ofisleri, Denetim Şirketleri ve Grup Şirketlere "Yaratıcı İşletme Değeri" (CEV) katmak.',
  },
];

const milestones = [
  { 
    year: '2019', 
    label: 'Kuruluş', 
    desc: 'CEV Finansal Teknolojiler A.Ş. İstanbul\'da kuruldu ve dijital muhasebe teknolojileri için altyapı çalışmalarına başladı.' 
  },

  { 
    year: '2020', 
    label: 'İlk Ürün', 
    desc: 'E-Defter analiz platformu piyasaya sürüldü ve program bağımsız E-Defter yönetimi geliştirildi.' 
  },

  { 
    year: '2021', 
    label: 'E-Belge Modülü', 
    desc: 'E-Fatura, E-Defter entegrasyonu, satır bazlı fatura analizleri ve vergi projeksiyon altyapıları geliştirildi.' 
  },

  { 
    year: '2022', 
    label: 'Ekosistem', 
    desc: 'E-Beyanname, Dijital GİB, çoklu sorgulama ve otomatik beyanname yönetim modülleri sisteme eklendi.' 
  },

  { 
    year: '2023', 
    label: 'Akıllı Raporlama', 
    desc: 'Mizan, muavin, mali tablolar ve toplu firma analizleri için gelişmiş raporlama altyapısı oluşturuldu.' 
  },

  { 
    year: '2024', 
    label: 'Büyüme', 
    desc: '1.000.000 satır incelemeye ulaşıldı ve tüm modüller tek platform altında entegre çalışmaya başladı.' 
  },

  { 
    year: '2025', 
    label: 'Dijital Dönüşüm', 
    desc: 'Şifresiz giriş sistemleri, otomatik veri akışları ve gece çalışan dijital operasyon altyapıları devreye alındı.' 
  },

  { 
    year: '2026', 
    label: 'Holistik Platform', 
    desc: 'CevFİN bütünsel muhasebe ağı yayına çıkıyor ve sizlerle buluşuyor.' 
  },
];
export default function KurumsalPage() {
  return (
    <div className="page-enter" style={{ paddingTop: 72 }}>
      <section className="section">
        <div className="container">

          {/* Hero */}
          <div className="corporate-hero">
            <FadeIn>
              <div className="section-label">Kurumsal</div>
              <h2 className="section-title" style={{ fontSize: 'clamp(2rem,5vw,3.5rem)' }}>
                Creative Enterprise Value<br />
                <span>(Girişimin Yaratıcı Değeri)</span>
              </h2>
              <p style={{ maxWidth: 560, margin: '0 auto', color: 'var(--slate-600)', fontSize: '1.0625rem', lineHeight: 1.75 }}>
                <strong>CEV Finansal Teknolojiler A.Ş.</strong> olarak 2019'dan bu yana Türkiye'nin
                önde gelen kurumlarına güvenilir, ölçeklenebilir ve holistik finansal teknoloji
                altyapısı sunuyoruz.
              </p>
            </FadeIn>
          </div>

          {/* Corporate cards */}
          <div className="corporate-grid">
            {corporate.map((item, i) => (
              <FadeIn key={i} delay={i * 0.1}>
                <div className="card corporate-card">
                  <IconBox size="lg" style={{ marginBottom: 24 }}>
                    {item.icon}
                  </IconBox>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </FadeIn>
            ))}
          </div>

          {/* Timeline */}
          <div style={{ marginTop: 80 }}>
            <SectionHeader
              label="Tarihçemiz"
              title='Büyüme <span>Yolculuğumuz</span>'
              center
            />
            <div style={{ position: 'relative', maxWidth: 700, margin: '0 auto' }}>
              <div style={{ position: 'absolute', left: '50%', top: 0, bottom: 0, width: 2, background: 'var(--slate-200)', transform: 'translateX(-50%)' }} />
              {milestones.map((m, i) => (
                <FadeIn key={i} delay={i * 0.1}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 32,
                    marginBottom: 32,
                    flexDirection: i % 2 === 0 ? 'row' : 'row-reverse',
                  }}>
                    <div style={{ flex: 1, textAlign: i % 2 === 0 ? 'right' : 'left' }}>
                      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.25rem', color: 'var(--blue-500)', marginBottom: 4 }}>{m.year}</div>
                      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--blue-950)', marginBottom: 4 }}>{m.label}</div>
                      <p style={{ fontSize: '.875rem' }}>{m.desc}</p>
                    </div>
                    <div style={{ width: 16, height: 16, borderRadius: '50%', background: 'var(--blue-500)', border: '3px solid var(--white)', boxShadow: '0 0 0 3px var(--blue-200)', flexShrink: 0, zIndex: 1 }} />
                    <div style={{ flex: 1 }} />
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>

          {/* Values */}
          <div style={{ marginTop: 80 }}>
            <SectionHeader
              label="Değerlerimiz"
              title='Bizi <span>Biz Yapan</span> İlkeler'
              center
            />
            <div className="values-grid">
              {values.map((v, i) => (
                <FadeIn key={i} delay={i * 0.1}>
                  <div className="card value-card">
                    <div className="icon-box" style={{ margin: '0 auto 20px' }}>{v.icon}</div>
                    <h4>{v.title}</h4>
                    <p>{v.desc}</p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>

          {/* Stats */}
          <FadeIn>
            <div style={{
              background: 'linear-gradient(135deg, var(--blue-600), var(--blue-500))',
              borderRadius: 'var(--radius-xl)',
              padding: '56px 94px',
              marginTop: 80,
              display: 'flex',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 100,
              textAlign: 'center',
            }}>
              {[
                { num: '100+', label: 'Aktif Müşteri' },
                { num: '19K+', label: 'Analiz Edilen E-Defter' },
                { num: '1.5M+', label: 'İşlenen E-Fatura' },
                { num: '100K+', label: 'GİB Sorgulamaları' },
                { num: '100K+', label: 'SGK Sorgulamaları' },
              ].map((stat, i) => (
                <div key={i}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 800, color: '#fff', marginBottom: 8 }}>{stat.num}</div>
                  <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '.875rem', fontWeight: 500 }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </FadeIn>

        </div>
      </section>
    </div>
  );
}
